export const tokens = {
    angleRight: 'ANGLE_RIGHT',
    arrow: 'ARROW',
    account: 'ACCOUNT',
    airCond: 'AIR_COND',
    arachide: 'ARACHIDE',
    avatar: 'AVATAR',
    bag: 'BAG',
    beef: 'BEEF',
    beeper: 'BEEPER',
    biking: 'BIKING',
    birthday: 'BIRTHDAY',
    blazon: 'BLAZON',
    blazonBorder: 'BLAZON_BORDER',
    breakfast: 'BREAKFAST',
    burgers: 'BURGERS',
    burgerKare: 'BURGER_KARE',
    cameraPlus: 'CAMERA_PLUS',
    card: 'CARD',
    catalog: 'CATALOG',
    ccHand: 'CC_HAND',
    ccHandLogo: 'CC_HAND_LOGO',
    ccIcon: 'CC_ICON',
    celeri: 'CELERI',
    checkbox: 'CHECKBOX',
    chicken: 'CHICKEN',
    childsMenu: 'CHILDS_MENU',
    circleAvatar: 'CIRCLE_AVATAR',
    circleCrown: 'CIRCLE_CROWN',
    circleMenuBeef: 'CIRCLE_MENU_BEEF',
    circleBeef: 'CIRCLE_BEEF',
    circleMenuChicken: 'CIRCLE_MENU_CHICKEN',
    circleChicken: 'CIRCLE_CHICKEN',
    circleColdDrink: 'CIRCLE_COLD_DRINK',
    circleMenuFish: 'CIRCLE_MENU_FISH',
    circleFish: 'CIRCLE_FISH',
    circleHotDrink: 'CIRCLE_HOT_DRINK',
    circleKingbox: 'CIRCLE_KINGBOX',
    circleLock: 'CIRCLE_LOCK',
    circlePencil: 'CIRCLE_PENCIL',
    circlePlus: 'CIRCLE_PLUS',
    circleOther: 'CIRCLE_OTHER',
    circleSalad: 'CIRCLE_SALAD',
    circleVeggie: 'CIRCLE_VEGGIE',
    circleWarning: 'CIRCLE_WARNING',
    clickAndParking: 'CLICK_AND_COLLECT_PICKUP_PARKING',
    clickAndCollect: 'CLICK_AND_COLLECT',
    clickAndCollectDrive: 'CLICK_AND_COLLECT_DRIVE',
    clickAndCollectGo: 'CLICK_AND_COLLECT_GO',
    clickAndCollectOnSite: 'CLICK_AND_COLLECT_ON_SITE',
    clickAndCollectParking: 'CLICK_AND_COLLECT_PICKUP_PARKING',
    coldDrinks: 'COLD_DRINKS',
    drinks: 'DRINKS',
    drinksEdit: 'DRINKS_EDIT',
    crab: 'CRAB',
    creditCard: 'CREDIT_CARD',
    crown: 'CROWN',
    deliverooLogo: 'DELIVEROO_LOGO',
    delivery: 'DELIVERY',
    deliveryInApp: 'DELIVERY_IN_APP',
    deliveryDeliveroo: 'DELIVERY_DELIVEROO',
    deliveryUbereats: 'DELIVERY_UBEREATS',
    deliveryHome: 'DELIVERY_HOME',
    drive: 'DRIVE',
    driveThru: 'DRIVE_THRU',
    eatIn: 'EAT_IN',
    egg: 'EGG',
    eye: 'EYE',
    export: 'EXPORT',
    facebook: 'FACEBOOK',
    family: 'FAMILY',
    fidelityCard: 'FIDELITY_CARD',
    filledLock: 'FILLED_LOCK',
    fish: 'FISH',
    fortuneWheel: 'FORTUNE_WHEEL',
    freeWifi: 'FREE_WIFI',
    geolocationFilled: 'GEOLOCATION_FILLED',
    gluten: 'GLUTEN',
    heartFamily: 'HEART_FAMILY',
    home: 'HOME',
    hotDrinks: 'HOT_DRINKS',
    info: 'INFO',
    instagram: 'INSTAGRAM',
    jobs: 'JOBS',
    kingBreakfast: 'KING_BREAKFAST',
    kingDeal: 'KING_DEAL',
    kingdom: 'KINGDOM',
    tableOrder: 'TABLE_ORDER',
    legal: 'LEGAL',
    light: 'LIGHT',
    littlePleasures: 'LITTLE_PLEASURES',
    lock: 'LOCK',
    logo: 'LOGO',
    lupin: 'LUPIN',
    mapTab: 'MAP_TAB',
    marker: 'MARKER',
    mealVoucher: 'MEAL_VOUCHER',
    menu: 'MENU',
    milk: 'MILK',
    more: 'MORE',
    mustard: 'MUSTARD',
    new: 'NEW',
    nightOpening: 'NIGHT_OPENING',
    noBacon: 'NO_BACON',
    now: 'NOW',
    nut: 'NUT',
    offers: 'OFFERS',
    onSite: 'ON_SITE',
    order: 'ORDER',
    orders: 'ORDERS',
    parking: 'PARKING',
    pickUpParking: 'PICK_UP_PARKING',
    playground: 'PLAYGROUND',
    preOrder: 'PRE_ORDER',
    prm: 'PRM',
    question: 'QUESTION',
    receipt: 'RECEIPT',
    roundLogo: 'ROUND_LOGO',
    salads: 'SALADS',
    sauce: 'SAUCE',
    babyBurgers: 'BABY_BURGERS',
    scan: 'SCAN',
    search: 'SEARCH',
    sesame: 'SESAME',
    shellfish: 'SHELLFISH',
    smallSnacks: 'SMALL_SNACKS',
    snacks: 'SNACKS',
    soja: 'SOJA',
    store: 'STORE',
    stores: 'STORES',
    sulfite: 'SULFITE',
    sweets: 'SWEETS',
    tableService: 'TABLE_SERVICE',
    takeaway: 'TAKEAWAY',
    terrace: 'TERRACE',
    ticket: 'TICKET',
    tiktok: 'TIKTOK',
    twitter: 'TWITTER',
    upload: 'UPLOAD',
    voucher: 'VOUCHER',
    waitingOnSite: 'WAITING_ON_SITE',
    wraps: 'WRAPS'
}
